import { useState, useEffect } from 'react'
import styles from './CustomerCasesDetail.module.css'
import { API_BASE_URL, getImageUrl } from '../config'

interface CaseListItem {
  id: number
  title: string
  slug: string
  logo: string
  industry_name: string
  region_name: string
  publish_date: string
}

const ArrowIcon = () => (
  <svg className={styles.arrowIcon} viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <path d="M885.113 489.373L628.338 232.599c-12.496-12.497-32.758-12.497-45.254 0-12.497 12.497-12.497 32.758 0 45.255l203.3 203.3H158.025c-17.036 0-30.846 13.811-30.846 30.846 0 17.036 13.811 30.846 30.846 30.846h628.36L583.084 746.147c-12.497 12.496-12.497 32.758 0 45.255 6.248 6.248 14.438 9.372 22.627 9.372s16.379-3.124 22.627-9.372l256.775-256.775a31.999 31.999 0 0 0 0-45.254z" fill="#FE6601"/>
  </svg>
)

interface CaseCardProps {
  caseItem: CaseListItem
  onCaseClick?: (caseItem: CaseListItem) => void
}

const CaseCard = ({ caseItem, onCaseClick }: CaseCardProps) => {
  return (
    <div className={styles.card} onClick={() => onCaseClick?.(caseItem)}>
      <div className={styles.thumbnail}>
        <img src={getImageUrl(caseItem.logo)} alt={caseItem.title} className={styles.thumbnailImage} />
      </div>
      <div className={styles.cardContent}>
          <p className={styles.cardTitle}>{caseItem.title}</p>
        <div className={styles.cardFooter}>
          <div className={styles.cardArrow}>
            <ArrowIcon />
          </div>
        </div>
      </div>
    </div>
  )
}

interface CustomerCasesDetailProps {
  onCaseClick?: (caseItem: CaseListItem) => void
}

const CustomerCasesDetail = ({ onCaseClick }: CustomerCasesDetailProps) => {
  const [cases, setCases] = useState<CaseListItem[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchCases = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/cases?page_size=100`)
        const result = await response.json()
        if (result.success) {
          setCases(result.data.list)
        }
      } catch (error) {
        console.error('Failed to fetch cases:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchCases()
  }, [])

  return (
    <div className={styles.container}>
      <p className={styles.sortNotice}>排名不分先后，按照首字母排序</p>
      {/* Case List */}
      <div className={styles.section}>
        {loading ? (
          <div className={styles.loading}>加载中...</div>
        ) : cases.length === 0 ? (
          <div className={styles.empty}>暂无案例</div>
        ) : (
          cases.map((caseItem) => (
            <CaseCard key={caseItem.id} caseItem={caseItem} onCaseClick={onCaseClick} />
          ))
        )}
      </div>
    </div>
  )
}

export default CustomerCasesDetail
